import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import { signin, signInWithGoogle, signInWithGitHub } from '../helpers/auth'
import Container from '@material-ui/core/Container'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Snackbar from '@material-ui/core/Snackbar'

import Alert from '@material-ui/lab/Alert'

export default class Signup extends Component {

    constructor(props) {
        super(props)
        this.state = {
            error: null,
            showError: false,
            email: "",
            password: ""
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    signInWithGoogleClicked = async () => {
        this.setState({ error: null })
        try {
            await signInWithGoogle();
        } catch (error) {
            this.setState({ error: error.message, showError: true })
        }
    }

    signInWithGitHubClicked = async () => {
        this.setState({ error: null })
        try {
            await signInWithGitHub();
        } catch (error) {
            this.setState({ error: error.message, showError: true })
        }
    }


    async handleSubmit(e) {
        e.preventDefault()
        this.setState({ error: null })
        try {
            await signin(this.state.email, this.state.password)
        } catch (error) {
            this.setState({ error: error.message, showError: true })
        }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        return (
            <Container maxWidth="lg">
                <Box my={10}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="center"
                        alignItems="center"
                        alignContent="center"
                        wrap="nowrap"
                    >
                        <Typography variant="h2" color="primary">
                            Login into The Real Chatty 101
                        </Typography>
                    </Grid>
                </Box>
                <Box my={10}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="center"
                        alignItems="center"
                        alignContent="center"
                        wrap="nowrap"
                    >
                        <form onSubmit={this.handleSubmit}>
                            <FormControl fullWidth style={{ marginBottom: "15px" }}>
                                <TextField
                                    fullWidth
                                    name="email"
                                    label="Email:"
                                    type="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                />
                            </FormControl>
                            <FormControl fullWidth style={{ marginBottom: "15px" }}>
                                <TextField
                                    fullWidth
                                    name="password"
                                    label="Password:"
                                    type="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                />
                            </FormControl>

                            <FormControl fullWidth style={{ marginBottom: "15px" }}>
                                <Button variant="contained" color="primary" size="large" type="submit">
                                    Login
                                </Button>
                            </FormControl>
                            {/* <FormControl style={{ marginBottom: "15px" }}>
                            </FormControl> */}
                            <ButtonGroup variant="contained" color="secondary" size="large">
                                <Button onClick={this.signInWithGitHubClicked} variant="contained" color="secondary" size="large">Login With GitHub</Button>
                                <Button onClick={this.signInWithGoogleClicked} variant="contained" color="secondary" size="large">Login with Google</Button>
                            </ButtonGroup>


                            <Typography variant="subtitle1" color="initial" style={{ marginTop: "20px" }}>
                                Don't Have an account? <Link to="/signup">Sign up</Link> a free account.
                            </Typography>

                        </form>

                    </Grid>
                </Box>
                <Snackbar open={this.state.showError} autoHideDuration={4000} onClose={() => { this.setState({ showError: false }) }}>
                    <Alert onClose={() => { this.setState({ showError: false }) }} severity="error">
                        {this.state.error}
                    </Alert>
                </Snackbar>
            </Container>
        )
    }
}
